import { getPermissions } from "@/helper/collection";
import store from "@/store";

export const cinemaRoutes = {
  path: "/my-cinema",
  name: "My-Cinemas",
  redirect: "/my-cinema",
  GogoName: "On Demand Management",
  component: {
    render(c) {
      return c("router-view");
    }
  },
  children: [
    {
      path: "add-schedule",
      name: "Add Schedule",
      component: () =>
        import(
          "@/components/MyCinemaComponents/MultiScheduling/addSchedulingV2.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          169,
          2
        )
      }
    },
    {
      path: "edit-schedule",
      name: "Edit MyCinema Schedule",
      component: () =>
        import(
          "@/components/MyCinemaComponents/MultiScheduling/editSchedule.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          169,
          2
        )
      }
    },
    {
      path: "schedule-list",
      name: "MyCinema Schedule List",
      component: () =>
        import(
          "@/components/MyCinemaComponents/MultiScheduling/scheduleListV2.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          170,
          2
        )
      }
    },
    {
      path: "movie-licence",
      name: "Movie Licence",
      component: () =>
        import(
          "@/components/MyCinemaComponents/MultiScheduling/movie-licence.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          190,
          2
        )
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/cinemaRoutes.js